import { Store } from "@ngxs/store";
import { Diary, IDiaryHandler, IDiaryManagerFactory, IDiaryManagerItem } from "@harlowe/core";
import { EncounterService } from "../../../services/encounter.service";
import { Encounters } from "../../../state/encounters/encounter-actions";
import { TealCompEncounterHeader } from "../../../models/encounter";
import { Observable, from, map, of, switchMap } from "rxjs";
import { EncounterDiaryHandler } from "./encounter-diary-handler";
import { inject } from "@angular/core";

export class EncounterDiaryManagerItem implements IDiaryManagerItem {
    constructor
        (
            private _diary: Diary,
            private _encounter: TealCompEncounterHeader | undefined,
            private _store: Store,
            private _handler: EncounterDiaryHandler | undefined
        ) {

    }

    get dueDate(): Date {
        return this._diary.dueDate ?? new Date();
    }
    
    get id(): number | string {
        return this._diary.id;
    }

    getHandler(): IDiaryHandler | undefined {
        return this._handler;
    }

    getRelatedToText(): string | undefined {
        return this._encounter?.party
    }


    goToRelatedItem(): void {
        if (this._diary?.encounterId)
            this._store.dispatch(new Encounters.EncounterOpenedFromDiary({ encounterId: this._diary.encounterId }));
    }

    getDiary(): Diary {
        return this._diary;
    }
}


export class EncounterDiaryManagerItemFactory implements IDiaryManagerFactory {

    private _encounterService: EncounterService = inject(EncounterService)
    private _store: Store = inject(Store)

    constructor
        (

    ) {

    }
    createDiaryManagerItems(diaries$: Observable<Diary[]>): Observable<IDiaryManagerItem[]> {
        //Get all the encounters associated with these diaries first
        return diaries$.pipe
            (
                switchMap(diaries => {
                    const ids = diaries.filter(d => d != undefined).map(d => d.encounterId as number);
                    if (ids.length === 0) return of([] as IDiaryManagerItem[]);
                    return from(this._encounterService.getEncounters(ids)).pipe(
                        map(encounters => diaries.map(d => {
                            const enc = encounters.find(e => d.encounterId === e.id);
                            const handler = enc ? new EncounterDiaryHandler(enc, this._encounterService, this._store) : undefined;
                            return new EncounterDiaryManagerItem(d, enc, this._store, handler);
                        }))
                    );
                })
            )
    }


    createDiaryManagerItem(diary$: Observable<Diary>): Observable<IDiaryManagerItem> {
        return this.createDiaryManagerItems(diary$.pipe(map(d => [d]))).pipe(map(d => d[0]))
    }

}

